import React from 'react'

const Loading = () => {
    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 h-screen">
            <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-btn-primary"></div>
                <span className="ml-4 text-lg text-white">Loading...</span>
            </div>
        </div>
    )
}

export default Loading